import React, { useEffect, useState } from "react";
import style from "./channels.module.scss";
import Skeleton from "../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const ChannelSkeleton = (props) => {

    return <div>
        <div className={style.header}>
            <div className={style.addChannelWrapper}>
                <div className={style.newChannelButton}>
                    <Skeleton type='rectangle' width='140px' height='44px' />
                </div>
            </div>
            <p className={style.mainTitle}><Skeleton type='rectangle' width='94px' height='44px' /></p>
        </div>
        <div className={style.listWrapper} style={{ marginBottom: '15px' }}><Skeleton type='rectangle' width='100%' height='56px' /></div>
        <div className={style.listWrapper} style={{ marginBottom: '15px' }}><Skeleton type='rectangle' width='100%' height='56px' /></div>
    </div>
}
export default ChannelSkeleton;
